export default "__VITE_ASSET__DcN5hvQ3__"